@import (reference) '../../../../constants/spacing.module.less';

.return-details-layout-column {
  display: flex;
  flex-flow: column nowrap;
  row-gap: @space-16;
  overflow-wrap: anywhere;
}

.address-column {
  .return-details-layout-column();
  grid-area: address-column;
}

.dates-column {
  .return-details-layout-column();
  grid-area: dates-column;
}

.rma-column {
  .return-details-layout-column();
  grid-area: rma-column;
}
